// matches all URLs or emails EXCEPT those enclosed in a style tag
export const URL_OR_EMAIL_PATTERN = /(https?:\/\/(?:www\.)?)?[-a-zA-Z0-9@\^\$:%\.“”'_\+~#=]{1,256}\.([A-Za-z0-9()]{1,6}[a-zA-Z]+)\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=>]*)(?![^\<\>]*\<\/style\>)/;
